import React, { useState } from "react";
import { InputWrapper, StyledInput, EyeIcon } from "./PasswordInputStyles";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

console.log("PW COMPONENT LOADED ✅");
console.log("Icons:", AiOutlineEye, AiOutlineEyeInvisible);
console.log("Styles:", InputWrapper, StyledInput, EyeIcon);
const PasswordInput = ({
  value,
  onChange,
  name,
  placeholder = "",
  required = false,
}) => {
  const [show, setShow] = useState(false);

  return (
    <InputWrapper>
      <StyledInput
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        name={name}
        placeholder={placeholder}
        required={required}
      />
      <EyeIcon
        type="button"
        onClick={() => setShow(!show)}
        aria-label={show ? "Ascunde parola" : "Arată parola"}
      >
        {show ? (
          <AiOutlineEyeInvisible size={20} />
        ) : (
          <AiOutlineEye size={20} />
        )}
      </EyeIcon>
    </InputWrapper>
  );
};

export default PasswordInput;
